import { SearchParams } from '@/types/common'
import {
  CreateGlobalConfiguration,
  UpdateGlobalConfiguration,
} from '@/types/globalConfiguration'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const globalConfiguration = {
  getAll(interfaceId: string, searchParams: SearchParams = {}) {
    const url = `/api/globalconfiguration?interfaceId=${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/globalconfiguration/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateGlobalConfiguration) {
    const url = '/api/globalconfiguration'
    return axiosClient.post(url, payload)
  },

  update(payload: UpdateGlobalConfiguration) {
    const url = '/api/globalconfiguration'
    return axiosClient.put(url, payload)
  },
}

export default globalConfiguration
